import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const MovieFoodSection = () => {
    const foods = [
        {
            image: 'assets/images/veg-burger.jpg',
            title: 'Classic Burger',
            description: 'Fresh, tasty burger perfect for your movie night.',
            price: '$8.99',
        },
        {
            image: 'assets/images/french-fry.jpg',
            title: 'Crispy Fries',
            description: 'Golden fries served hot and crispy.',
            price: '$4.99',
        },
        {
            image: 'assets/images/salted-popcorn.jpg',
            title: 'Salted Popcorn',
            description: 'A movie-time favorite for every drive-in show.',
            price: '$5.99',
        },
        {
            image: 'assets/images/cocacola-value.jpg',
            title: 'Cold Drinks',
            description: 'Enjoy Coke and refreshing drinks with your meal.',
            price: '$3.99',
        },
        {
            image: 'assets/images/popcorn.jpg',
            title: 'Movie Popcorn Tub',
            description: 'Fresh popcorn served in a large tub for sharing.',
            price: '$6.99',
        },
        {
            image: 'assets/images/topbg-1.jpg',
            title: 'Snack Combo',
            description: 'A tasty combo of snacks and drinks for the full movie experience.',
            price: '$12.99',
        },
    ]

    return (
        <section className="movie-food-sec" style={{ backgroundImage: `url('assets/images/topbg-2.jpg')` }}>
            <Container>
                <div className="section-title text-center">
                    <span>Fresh Food While You Watch</span>
                    <h2>Movie Snacks & Food</h2>
                    <p>
                        Order burgers, fries, popcorn, cold drinks, and more directly from your phone
                        and enjoy them during the movie.
                    </p>
                </div>

                <Row className="align-items-center">
                    <Col lg={5}>
                        <div className="food-feature-box">
                            <div className="food-feature-img">
                                <img src="assets/images/popcorn.jpg" alt="Movie food" />
                            </div>

                            <div className="food-feature-content">
                                <span>Drive-In Food Ordering</span>
                                <h3>Hungry During The Show?</h3>
                                <p>
                                    Browse the menu, add your favorite snacks, and place your food order
                                    while watching your movie from the comfort of your car.
                                </p>

                                <a href="/food-menu" className="food-main-btn">
                                    View Food Menu
                                </a>
                            </div>
                        </div>
                    </Col>

                    <Col lg={7}>
                        <Row>
                            {foods.map((item, index) => (
                                <Col md={6} key={index}>
                                    <div className="movie-food-card">
                                        <div className="movie-food-img">
                                            <img src={item.image} alt={item.title} />
                                        </div>

                                        <div className="movie-food-info">
                                            <div>
                                                <h4>{item.title}</h4>
                                                <p>{item.description}</p>
                                            </div>

                                            <div className="movie-food-bottom">
                                                <strong>{item.price}</strong>
                                                <a href="/">Order Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default MovieFoodSection